import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.textContent = "Hello World!";
  }

  disable() {
    this.scroll_position = document.documentElement.scrollTop;

    document.body.classList.add("menu-open");

    document.querySelector("main").style.marginTop =
      `-${this.scroll_position}px`;
  }

  enable() {
    document.body.classList.remove("menu-open");
    document.querySelector("main").style.marginTop = "";

    document.documentElement.scrollTop = this.scroll_position;
  }
}
